import {atom, computed, map as storeMap} from 'nanostores';
import {toast} from 'sonner';
import {NotificationPanelType} from './notificationModels/panel/notificationPanel';
import {NotificationCreate} from './notificationModels/notifications';
import {ToastRecordCreate} from './notificationModels/notificationsBase';

export const $notifications = storeMap<Record<string, string | number>>({});

if (import.meta.hot) {
  import.meta.hot.accept();
}

export const $notificationItems = atom<NotificationPanelType[]>([]);

export const removeNotificationItem = (key: string) => {
  $notificationItems.set(
    $notificationItems.get().filter(n => {
      return n.id !== key;
    }),
  );
};

export const $activeNotifications = computed(
  [$notifications],
  notifications => {
    const count = Object.values(notifications).filter(val => !!val).length;
    return count;
  },
);

/**
 * A single wrapper for all toast types
 */
export function notify(notification: NotificationPanelType): void;
export function notify(notification: ToastRecordCreate): string | number;
export function notify(notification: NotificationCreate) {
  // Toast handling.
  if (notification.type === 'Toast') {
    const existingId = $notifications.get()[notification.id];

    const cleanup = () => {
      $notifications.setKey(notification.id, undefined);
      removeNotificationItem(notification.id);
    };

    const toastOptions = notification.toastOptions || {};

    toastOptions.toasterId = 'global';

    const toastId = toast[notification.toastType](notification.title, {
      id: existingId,
      ...toastOptions,
      description: notification.description?.trim() || undefined,
      onDismiss: cleanup,
      onAutoClose: cleanup,
    });

    return toastId;
  }

  const item: NotificationPanelType = {
    ...notification,
    createdAt: Date.now(),
  };

  const current = $notificationItems.get();
  const existingIdx = current.findIndex(n => n.id === notification.id);
  if (existingIdx >= 0) {
    // Replace in place so re-firing the same notification refreshes it.
    const next = current.slice();
    //next[existingIdx] = item;
    next[existingIdx] = item;
    $notificationItems.set(next);
  } else {
    $notificationItems.set([item, ...current]);
  }
}
